import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideObservabilityAuth } from './auth/auth.providers';
import { apiInterceptor } from './interceptors/api.interceptor';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([apiInterceptor])),
    provideAnimations(),
    provideAppInitializer(() => {
      inject(MatIconRegistry).addSvgIcon(
        'automic',
        inject(DomSanitizer).bypassSecurityTrustResourceUrl('/icons/automic.svg')
      );
    }),
    ...provideObservabilityAuth()
  ]
};
